import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { fetchApi } from "../../helper/api";
import { useCallback, useEffect } from "react";
import { MQTTI } from "../../helper/mqttClient";

const CameraStreaming = (props) => {
  const location = useLocation();
  const ddns = location.state.data.ddns;
  const idCam = location.state.data.id;
  const idIpc = location.state.data.idIpc;
  const localIp = location.state.data.localIp.split("/")[2];
  const ptzBtns = [
    {
      name: "pan_upperleft",
      icon: (
        <i
          style={{ transform: "rotate(-45deg)" }}
          className="las la-angle-up"
        ></i>
      ),
      isDisable: false,
    },
    {
      name: "pan_upper",
      icon: <i className="las la-angle-up"></i>,
      isDisable: false,
    },
    {
      name: "pan_upperright",
      icon: (
        <i
          style={{ transform: "rotate(45deg)" }}
          className="las la-angle-up"
        ></i>
      ),
      isDisable: false,
    },
    {
      name: "pan_left",
      icon: <i className="las la-angle-left"></i>,
      isDisable: false,
    },
    {
      name: "pan",
      icon: <i className="las la-exclamation-circle"></i>,
      isDisable: true,
    },
    {
      name: "pan_right",
      icon: <i className="las la-angle-right"></i>,
      isDisable: false,
    },
    {
      name: "pan_bottomleft",
      icon: (
        <i
          style={{ transform: "rotate(45deg)" }}
          className="las la-angle-down"
        ></i>
      ),
      isDisable: false,
    },
    {
      name: "pan_bottom",
      icon: <i className="las la-angle-down"></i>,
      isDisable: false,
    },
    {
      name: "pan_bottomright",
      icon: (
        <i
          style={{ transform: "rotate(-45deg)" }}
          className="las la-angle-down"
        ></i>
      ),
      isDisable: false,
    },
  ];
  useEffect(() => {
    const topic = `camCommand/${idIpc}/${localIp}`;
    // console.log(topic, idIpc, localIp);
    MQTTI().publish(`${topic}/watch`);

    return () => {
      MQTTI().publish(`${topic}/leave`);
    };
  }, []);

  const handlePTZ = (link) => {
    // console.log(link, idCam, idIpc);
    fetchApi(`api/Ipc/camPTZ/${idIpc}?cmdindex=${link},${idCam}`, "GET", true);
  };

  const setDefault = useCallback(async () => {
    await fetchApi(
      `api/Ipc/camParkAction/${idIpc}?cmdIndex=${idCam}`,
      "GET",
      true
    );
  }, [idCam, idIpc]);

  return (
    // <iframe className="w-100 h-100" src="admin:Lcs032020@ampera.camdvr.org:4000/streaming/channels/2/httppreview" />
    <div
      className="w-100 d-flex justify-content-between align-items-start px-2"
      style={{
        height: "80vh",
        gap: "2em",
      }}
    >
      <div className="w-100 h-100 shadow-sm">
        <iframe className="w-100 h-100" src={ddns} title="camera" />
      </div>
      <div
        className="card rounded shadow-sm px-2 py-3 d-flex flex-column justify-content-center gap-1 mb-0"
        style={{
          minWidth: "fit-content",
        }}
      >
        <div className="ml-2" style={{ maxWidth: "200px" }}>
          {ptzBtns.map((item) => (
            <Button
              size="large"
              ml={1}
              mb={1}
              disabled={item.isDisable}
              key={item.name}
              onClick={() => handlePTZ(item.name)}
              variant="outlined"
              className="outline-none"
            >
              {item.icon}
            </Button>
          ))}
        </div>
        <div className="d-flex justify-content-center gap-1">
          <Button
            size="large"
            variant="outlined"
            onClick={() => handlePTZ("zoom_in")}
            className="outline-none"
          >
            <i className="las la-search-plus"></i>
          </Button>
          <Button
            size="large"
            variant="outlined"
            onClick={() => handlePTZ("zoom_out")}
            className="outline-none"
          >
            <i className="las la-search-minus"></i>
          </Button>
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button className="w-100" onClick={() => setDefault()}>
            Atur sebagai default
          </Button>
        </div>
      </div>
    </div>
  );
};
export default CameraStreaming;
